export const SET_LOADING_STATE = "SET_LOADING_STATE";
export const SET_MODAL_STATE = "SET_MODAL_STATE";

export const USER_CHECK_IS_LOGGED_IN = "USER_CHECK_IS_LOGGED_IN";
export const USER_SET_PENDING_CONFIRMATION = "USER_SET_PENDING_CONFIRMATION";
export const USER_RESEND_CONFIRMATION = "USER_RESEND_CONFIRMATION";
export const USER_SET_IS_LOADING = "USER_SET_IS_LOADING ";

export const AUTH_INITIATE_LOGIN = "AUTH_INITIATE_LOGIN";
export const AUTH_SET_LOGGED_IN = "AUTH_SET_LOGGED_IN";
export const AUTH_INITIATE_SIGNUP = "AUTH_INITIATE_SIGNUP";
export const AUTH_INITIATE_FORGOTTEN_PASSWORD =
  "AUTH_INITIATE_FORGOTTEN_PASSWORD";

export const POST_REGATTA_FORMS = "POST_REGATTA_FORMS";
export const SUBMIT_REGATTA_FORMS = "SUBMIT_REGATTA_FORMS";
export const REGATTA_ASSESSMENT_IS_LOADING = "REGATTA_ASSESSMENT_IS_LOADING";
export const SUBMIT_REGATTA_ASSESSMENT = "SUBMIT_REGATTA_ASSESSMENT";
export const REGATTA_ASSESSMENT_SUBMITTED = "REGATTA_ASSESSMENT_SUBMITTED";
export const POST_AVAILABILITY_CALENDAR = "POST_AVAILABILITY_CALENDAR";
export const POST_USER_FEEDBACK_DATA = "POST_USER_FEEDBACK_DATA";
export const POST_USER_FEEDBACK_DISMISSAL = "POST_USER_FEEDBACK_DISMISSAL";
export const POST_USER_FEEDBACK_CLOSE = "POST_USER_FEEDBACK_CLOSE";

export const AUTH_INITIATE_LOGOUT = "AUTH_INITIATE_LOGOUT";
export const AUTH_SET_LOGGED_OUT = "AUTH_SET_LOGGED_OUT";
export const SET_IS_AUTHENTICATING = "SET_IS_AUTHENTICATING";

export const AUTH_SHOULD_ONBOARD = "AUTH_SHOULD_ONBOARD";
export const AUTH_SHOULD_REDIRECT_TO_PROFILE =
  "AUTH_SHOULD_REDIRECT_TO_PROFILE";

export const AUTH_ERROR_SET = "AUTH_ERROR_SET";
export const USER_SET = "USER_SET";

export const ONBOARD_LOADED_STATE = "ONBOARD_LOADED_STATE";
export const ONBOARD_UPDATE_STATE = "ONBOARD_UPDATE_STATE";
export const ONBOARD_UPDATE_STATE_ITEM = "ONBOARD_UPDATE_STATE_ITEM";

export const CREATING_USER_IN_PROFILE = "CREATING_USER_IN_PROFILE";
export const UPDATE_USER_IN_PROFILE = "UPDATE_USER_IN_PROFILE";
export const UPDATE_USER_IN_PROFILE_SILENT = "UPDATE_USER_IN_PROFILE_SILENT";
export const UPDATE_CV_SILENT = "UPDATE_CV_SILENT";
export const GET_USER_IN_PROFILE = "GET_USER_IN_PROFILE";
export const HAS_LINKED_PROFILE_ACCOUNT = "HAS_LINKED_PROFILE_ACCOUNT";
export const CHECK_HAS_LINKED_PROFILE_ACCOUNT =
  "CHECK_HAS_LINKED_PROFILE_ACCOUNT";

export const TIMESHEETS_REQUEST_DATA = "TIMESHEETS_REQUEST_DATA";
export const TIMESHEETS_SET_IS_LOADING = "TIMESHEETS_SET_IS_LOADING";
export const TIMESHEETS_SET_DATA = "TIMESHEETS_SET_DATA";
export const NON_ATTENDANCE_LOOKUP_DATA = "NON_ATTENDANCE_LOOKUP_DATA";

export const BOOKING_REQUEST_DATA = "BOOKING_REQUEST_DATA";
export const BOOKING_SET_IS_LOADING = "BOOKING_SET_IS_LOADING";
export const BOOKING_SET_DATA = "BOOKING_SET_DATA";

export const PAYSLIPS_REQUEST_DATA = "PAYSLIPS_REQUEST_DATA";
export const PAYSLIPS_SET_IS_LOADING = "PAYSLIPS_SET_IS_LOADING";
export const PAYSLIPS_SET_DATA = "PAYSLIPS_SET_DATA";

export const HOLIDAY_REQUEST_DATA = "HOLIDAY_REQUEST_DATA";
export const HOLIDAY_SET_IS_LOADING = "HOLIDAY_SET_IS_LOADING";
export const HOLIDAY_SET_DATA = "HOLIDAY_SET_DATA";
export const HOLIDAY_HISTORY_SET_DATA = "HOLIDAY_HISTORY_SET_DATA";
export const POST_HOLIDAY_REQUEST_FORM = "POST_HOLIDAY_REQUEST_FORM";
export const SET_HOLIDAY_REQUEST_FORM_LOADING =
  "SET_HOLIDAY_REQUEST_FORM_LOADING";
export const SET_HOLIDAY_REQUEST_FORM_SUBMITTED =
  "SET_HOLIDAY_REQUEST_FORM_SUBMITTED";

export const LATEST_JOBS_REQUEST_DATA = "LATEST_JOBS_REQUEST_DATA";
export const LATEST_JOBS_SET_IS_LOADING = "LATEST_JOBS_SET_IS_LOADING";
export const LATEST_JOBS_SET_DATA = "LATEST_JOBS_SET_DATA";

export const APPLY_FOR_JOB = "APPLY_FOR_JOB";
export const APPLY_API_LOADING = "APPLY_API_LOADING";
export const APPLY_API_ERROR = "APPLY_API_ERROR";
export const APPLY_API_SUCCESS = "APPLY_API_SUCCESS";

export const STORE_USER_DATA_IN_APP = "STORE_USER_DATA_IN_APP";
export const SET_CV_IS_LOADING = "SET_CV_IS_LOADING ";

export const GET_ADDRESS_LIST = "GET_ADDRESS_LIST";
export const STORE_ADDRESS_LIST_IN_APP = "STORE_ADDRESS_LIST_IN_APP";

export const STORE_WORK_HISTORY_IN_APP = "STORE_WORK_HISTORY_IN_APP";
export const STORE_WORK_REFERENCES_IN_APP = "STORE_WORK_REFERENCES_IN_APP";

export const STORE_UMBRACO_CONTENT = "STORE_UMBRACO_SUBTITLES";

export const POSTCODE_ERROR_SET = "POSTCODE_ERROR_SET";
export const POSTCODE_ERROR_CLEAR = "POSTCODE_ERROR_CLEAR";

export const SET_ERROR = "SET_ERROR";

export const ADD_SERVER_ERROR = "ADD_SERVER_ERROR";
export const CLEAR_SERVER_ERRORS = "CLEAR_SERVER_ERRORS";

export const TIMESHEET_IS_UPDATING = "TIMESHEET_IS_UPDATING";
export const TIMESHEET_UPDATE_SUCCESS = "TIMESHEET_UPDATE_SUCCESS";
export const TIMESHEET_UPDATE_FAILED = "TIMESHEET_UPDATE_FAILED";
export const TIMESHEET_SEND_FEEDBACK = "TIMESHEET_SEND_FEEDBACK";

export const HTTP_404_ERROR = "HTTP_404_ERROR";
export const HTTP_500_ERROR = "HTTP_500_ERROR";
export const HTTP_OTHER_ERROR = "HTTP_OTHER_ERROR";

export const DISMISS_ERROR_MODAL = "DISMISS_ERROR_MODAL";
export const UPDATE_GENERAL_CONSENT = "UPDATE_GENERAL_CONSENT";
export const RTW_INITIATE_CHECK = "RTW_INITIATE_CHECK";
export const RTW_CHECK_ERROR = "RTW_CHECK_ERROR";
export const RTW_CHECK_SUCCESS = "RTW_CHECK_SUCCESS";
export const RTW_VERIFICATION_QUEUE_IS_LOADING =
  "RTW_VERIFICATION_QUEUE_IS_LOADING";
export const RTW_VERIFICATION_QUEUE_SIZE = "RTW_VERIFICATION_QUEUE_SIZE";
export const RTW_VERIFICATION_QUEUE_SIZE_SUCCESS =
  "RTW_VERIFICATION_QUEUE_SIZE_SUCCESS";
export const RTW_VERIFICATION_QUEUE_POSITION =
  "RTW_VERIFICATION_QUEUE_POSITION";
export const RTW_VERIFICATION_QUEUE_REGISTER =
  "RTW_VERIFICATION_QUEUE_REGISTER";
export const RTW_VERIFICATION_FINISHED = "RTW_VERIFICATION_FINISHED";
export const RTW_VERIFICATION_QUEUE_DETAILS = "RTW_VERIFICATION_QUEUE_DETAILS";

export const DOCUMENTATION_INITIATE_UPLOAD = "DOCUMENTATION_INITIATE_UPLOAD";
export const DOCUMENTATION_ERROR = "DOCUMENTATION_ERROR";
export const DOCUMENTATION_SUCCESS = "DOCUMENTATION_SUCCESS";

export const CONTINUE_REGISTRATION = "CONTINUE_REGISTRATION";
export const SET_CONTINUING_REGISTRATION = "SET_CONTINUING_REGISTRATION";

export const MARK_DOCUMENT_READ = "MARK_DOCUMENT_READ";
export const MARK_DOCUMENT_READ_GB = "MARK_DOCUMENT_READ_GB";
export const MARK_DOCUMENT_READ_SB = "MARK_DOCUMENT_READ_SB";
export const MARK_DOCUMENT_READ_KINGSPAN = "MARK_DOCUMENT_READ_KINGSPAN";
export const MARK_DOCUMENT_READ_PUSTERLA = "MARK_DOCUMENT_READ_PUSTERLA";
export const MARK_DOCUMENT_READ_REGATTA = "MARK_DOCUMENT_READ_REGATTA";
export const MARK_DOCUMENT_READ_PECAN = "MARK_DOCUMENT_READ_PECAN";
export const MARK_DOCUMENT_READ_WOODLAND = "MARK_DOCUMENT_READ_WOODLAND";

export const MARK_DOCUMENT_READ_CARLTON_FOREST =
  "MARK_DOCUMENT_READ_CARLTON_FOREST";
export const POST_CARLTON_FOREST_FORMS = "POST_CARLTON_FOREST_FORMS";
export const SUBMIT_CARLTON_FOREST_FORMS = "SUBMIT_CARLTON_FOREST_FORMS";
export const SET_INDUCTION_FORM_ITEM_CARLTON_FOREST_LOADING =
  "SET_INDUCTION_FORM_ITEM_CARLTON_FOREST_LOADING";
export const SET_IPN_LOADING = "SET_IPN_LOADING";
export const SET_CARLTON_FOREST_READING_LOADING =
  "SET_CARLTON_FOREST_READING_LOADING";
export const SET_INDUCTION_FORM_CARLTON_FOREST_LOADING =
  "SET_INDUCTION_FORM_CARLTON_FOREST_LOADING";
export const POST_SSOW_CARLTON_FOREST = "POST_SSOW_CARLTON_FOREST";
export const SET_SSOW_CARLTON_FOREST_LOADING =
  "SET_SSOW_CARLTON_FOREST_LOADING";
export const SET_SSOW_ITEMS_CARLTON_FOREST_LOADING =
  "SET_SSOW_ITEMS_CARLTON_FOREST_LOADING";

export const POST_ABM_FORMS = "POST_ABM_FORMS";
export const SUBMIT_ABM_FORMS = "SUBMIT_ABM_FORM";
export const ABM_ONBOARDING_SUBMITTED = "ABM_ONBOARDING_SUBMITTED";

export const POST_PUSTERLA_ASSESSMENT_SCORE = "POST_PUSTERLA_ASSESSMENT_SCORE";
export const POST_PUSTERLA_FORMS = "POST_PUSTERLA_FORMS";
export const SUBMIT_PUSTERLA_FORMS = "SUBMIT_PUSTERLA_FORMS";

export const SET_KINGSPAN_READING_LOADING = "SET_KINGSPAN_READING_LOADING";
export const KINGSPAN_ASSESSMENT_IS_LOADING = "KINGSPAN_ASSESSMENT_IS_LOADING";
export const SUBMIT_KINGSPAN_ASSESSMENT = "SUBMIT_KINGSPAN_ASSESSMENT";
export const KINGSPAN_ASSESSMENT_SUBMITTED = "KINGSPAN_ASSESSMENT_SUBMITTED";

export const SET_PUSTERLA_READING_LOADING = "SET_PUSTERLA_READING_LOADING";
export const SET_REGATTA_READING_LOADING = "SET_REGATTA_READING_LOADING";
export const SET_SOP_LOADING = "SET_SOP_LOADING";
export const SET_PECAN_READING_LOADING = "SET_PECAN_READING_LOADING";

export const POST_REFLEX_ALLEN_FORM = "POST_REFLEX_ALLEN_FORM";
export const REQUEST_REFLEX_ALLEN_FORMS = "REQUEST_REFLEX_ALLEN_FORMS";
export const REFRESH_SECTIONS = "REFRESH_SECTIONS";

export const SET_DOWNLOADING_REFLEX_ALLEN_FORMS =
  "SET_DOWNLOADING_REFLEX_ALLEN_FORMS";
export const SET_DOWNLOADING_GREAT_BEAR_FORMS =
  "SET_DOWNLOADING_GREAT_BEAR_FORMS";
export const SET_REFLEX_ALLEN_FORMS = "SET_REFLEX_ALLEN_FORMS";

export const POST_REFLEX_ALLEN_INDUCTION_PROGRAMME =
  "POST_REFLEX_ALLEN_INDUCTION_PROGRAMME";

export const POST_ROYAL_MAIL_FORM = "POST_ROYAL_MAIL_FORM";
export const SUBMIT_ROYAL_MAIL_ONBOARDING = "SUBMIT_ROYAL_MAIL_ONBOARDING";
export const ROYAL_MAIL_ONBOARDING_SUBMITTED =
  "ROYAL_MAIL_ONBOARDING_SUBMITTED";

export const POST_GATE_FORM = "POST_GATE_FORM";
export const SUBMIT_GATE_FORM = "SUBMIT_GATE_FORM";
export const GATE_ONBOARDING_SUBMITTED = "GATE_ONBOARDING_SUBMITTED";

export const POST_DNATA_FORM = "POST_DNATA_FORM";
export const POST_SWISSPORT_FORM = "POST_SWISSPORT_FORM";
export const POST_SOP_KINGSPAN = "POST_SOP_KINGSPAN";
export const POST_SOP_DOCUMENT_SUCCESS = "POST_SOP_DOCUMENT_SUCCESS";
export const SUBMIT_DNATA_FORM = "SUBMIT_DNATA_FORM";
export const UPLOAD_DNATA_PDF = "UPLOAD_DNATA_PDF";
export const SUBMIT_DNATA_EXTRA_FORM = "SUBMIT_DNATA_EXTRA_FORM";
export const SET_DNATA_EXTRA_FORM_LOADING = "SET_DNATA_EXTRA_FORM_LOADING";
export const DNATA_ONBOARDING_SUBMITTED = "DNATA_ONBOARDING_SUBMITTED";
export const DNATA_TEST_SUBMITTED = "DNATA_TEST_SUBMITTED";
export const SUBMIT_DNATA_TEST = "SUBMIT_DNATA_TEST";
export const DNATA_TEST_IS_LOADING = "DNATA_TEST_IS_LOADING";
export const SWISSPORT_IS_LOADING = "SWISSPORT_IS_LOADING";
export const PECAN_ASSESSMENT_IS_LOADING = "PECAN_ASSESSMENT_IS_LOADING";
export const SUBMIT_PECAN_ASSESSMENT = "SUBMIT_PECAN_ASSESSMENT";
export const SUBMIT_PECAN_ASSESSMENT_SUCCESS =
  "SUBMIT_PECAN_ASSESSMENT_SUCCESS";
export const SUBMIT_PECAN_FORMS = "SUBMIT_PECAN_FORMS";
export const SUBMIT_PECAN_FORMS_SUCCESS = "SUBMIT_PECAN_FORMS_SUCCESS";

export const POST_PECAN_FORMS = "POST_PECAN_FORMS";

export const CV_PROGRESS = "CV_PROGRESS";

export const POST_DRIVING_FORM = "POST_DRIVING_FORM";
export const SUBMIT_DRIVING_ONBOARDING = "SUBMIT_DRIVING_ONBOARDING";
export const DRIVING_ONBOARDING_SUBMITTED = "DRIVING_DRIVING_SUBMITTED";

export const TEST_3_MONTH_PROMPT = "TEST_3_MONTH_PROMPT";

export const FOOD_HANDLING_FORM_SUBMITTED = "FOOD_HANDLING_FORM_SUBMITTED";
export const MANUAL_HANDLING_FORM_SUBMITTED = "MANUAL_HANDLING_FORM_SUBMITTED";
export const CASH_ALCOHOL_SUBMITTED = "CASH_ALCOHOL_SUBMITTED";

export const NON_HGV_ASSESSMENT_SUBMITTED = "NON_HGV_ASSESSMENT_SUBMITTED";
export const NON_HGV_ASSESSMENT_PASSED = "NON_HGV_ASSESSMENT_PASSED";

export const DRIVER_ASSESSMENT_SUBMITTED = "DRIVER_ASSESSMENT_SUBMITTED";
export const DRIVER_ASSESSMENT_PASSED = "DRIVER_ASSESSMENT_PASSED";

export const NIGHT_WORKER_SUBMITTED = "NIGHT_WORKER_SUBMITTED";
export const POST_NIGHT_WORKER_FORM = "POST_NIGHT_WORKER_FORM";
export const POST_NIGHT_WORKER_SB = "POST_NIGHT_WORKER_SB";

export const AUTHORITY_FOR_PAYMENTS_SUBMITTED =
  "AUTHORITY_FOR_PAYMENTS_SUBMITTED";
export const POST_AUTHORITY_FOR_PAYMENTS_FORM =
  "POST_AUTHORITY_FOR_PAYMENTS_FORM";

export const UPDATE_DETAILS_STORE_DATE = "UPDATE_DETAILS_STORE_DATE";

export const CONTRACT_FOR_SERVICES_SUBMITTED =
  "CONTRACT_FOR_SERVICES_SUBMITTED";

export const NOTIFICATIONS_LOAD_REQUEST = "NOTIFICATIONS_LOAD_REQUEST";
export const NOTIFICATIONS_LOAD_ERROR = "NOTIFICATIONS_LOAD_ERROR";
export const NOTIFICATIONS_LOAD_SUCCESS = "NOTIFICATIONS_LOAD_SUCCESS";

export const POST_GREAT_BEAR_INDUCTION_PROGRAMME =
  "POST_GREAT_BEAR_INDUCTION_PROGRAMME";

export const SET_GREAT_BEAR_INDUCTION_PROGRAMME =
  "SET_GREAT_BEAR_INDUCTION_PROGRAMME";

export const GREAT_BEAR_READING_SET_IS_LOADING =
  "GREAT_BEAR_READING_SET_IS_LOADING";

export const NOTIFICATIONS_LAST_READ_REQUEST =
  "NOTIFICATIONS_LAST_READ_REQUEST";
export const NOTIFICATIONS_LAST_READ_ERROR = "NOTIFICATIONS_LAST_READ_ERROR";
export const NOTIFICATIONS_LAST_READ_SUCCESS =
  "NOTIFICATIONS_LAST_READ_SUCCESS";

export const NOTIFICATIONS_READ_UPDATE_REQUEST =
  "NOTIFICATIONS_READ_UPDATE_REQUEST";
export const NOTIFICATIONS_READ_UPDATE_ERROR =
  "NOTIFICATIONS_READ_UPDATE_ERROR";
export const NOTIFICATIONS_READ_UPDATE_SUCCESS =
  "NOTIFICATIONS_READ_UPDATE_SUCCESS";

export const POST_EXPOSURE_BASED_MEMORY_TEST =
  "POST_EXPOSURE_BASED_MEMORY_TEST ";
export const POST_BIG_5_PERSONALITY_TEST = "POST_BIG_5_PERSONALITY_TEST";
export const POST_DISC_ASSESSMENT_TEST = "POST_DISC_ASSESSMENT_TEST";
export const POST_NONVERBAL_IMMEDIACY_TEST = "POST_NONVERBAL_IMMEDIACY_TEST";

export const SUBMIT_GLAA_FORMS = "SUBMIT_GLAA_FORMS";

export const BIG_5_PERSONALITY_TEST_SUBMITTED =
  "BIG_5_PERSONALITY_TEST_SUBMITTED";
export const EXPOSURE_BASED_MEMORY_TEST_SUBMITTED =
  "EXPOSURE_BASED_MEMORY_TEST_SUBMITTED";
export const NONVERBAL_IMMEDIACY_TEST_SUBMITTED =
  "NONVERBAL_IMMEDIACY_TEST_SUBMITTED";
export const DISC_ASSESSMENT_TEST_SUBMITTED = "DISC_ASSESSMENT_TEST_SUBMITTED";
export const DISK_ASSESSMENT_TEST_LOADING = "DISK_ASSESSMENT_TEST_LOADING";

export const POST_NHS_REFERENCES_FORM = "POST_NHS_REFERENCES_FORM";

export const SUBMIT_UMBRELLA_DECLARATION_FORM =
  "SUBMIT_UMBRELLA_DECLARATION_FORM";

export const MARK_DOCUMENT_READ_CPI = "MARK_DOCUMENT_READ_CPI";
export const SET_CPI_READING_LOADING = "SET_CPI_READING_LOADING";

export const MARK_DOCUMENT_READ_THANET_COUNCIL =
  "MARK_DOCUMENT_READ_THANET_COUNCIL";
export const SET_THANET_COUNCIL_READING_LOADING =
  "SET_THANET_COUNCIL_READING_LOADING";
export const POST_RISK_ASSESSMENT_THANET_COUNCIL =
  "POST_RISK_ASSESSMENT_THANET_COUNCIL";
export const SET_RISK_ASSESSMENT_LOADING_THANET_COUNCIL =
  "SET_RISK_ASSESSMENT_LOADING_THANET_COUNCIL";
export const POST_THANET_COUNCIL_FORMS = "POST_THANET_COUNCIL_FORMS";
export const SUBMIT_THANET_COUNCIL_FORMS = "SUBMIT_THANET_COUNCIL_FORMS";

export const YOTI_FETCH_IFRAME = "YOTI_FETCH_IFRAME";
export const YOTI_SET_URL = "YOTI_SET_URL";
export const POST_WOODLAND_FORMS = "POST_WOODLAND_FORMS";

export const MARK_DOCUMENT_READ_MOLECULAR = "MARK_DOCUMENT_READ_MOLECULAR";
export const POST_MOLECULAR_FORMS = "POST_MOLECULAR_FORMS";
export const SUBMIT_MOLECULAR_ASSESSMENT = "SUBMIT_MOLECULAR_ASSESSMENT";
export const MOLECULAR_ASSESSMENT_IS_LOADING =
  "MOLECULAR_ASSESSMENT_IS_LOADING";
export const MOLECULAR_ASSESSMENT_SUBMITTED = "MOLECULAR_ASSESSMENT_SUBMITTED";

export const MARK_DOCUMENT_READ_COMPLEAT_FOOD =
  "MARK_DOCUMENT_READ_COMPLEAT_FOOD";
export const SET_COMPLEAT_FOOD_READING_LOADING =
  "SET_COMPLEAT_FOOD_READING_LOADING";
export const POST_COMPLEAT_FOOD_FORM = "POST_COMPLEAT_FOOD_FORM";
export const SET_COMPLEAT_FOOD_FORM_LOADING = "SET_COMPLEAT_FOOD_FORM_LOADING";
export const MARK_DOCUMENT_READ_GROW_UP_FARMS =
  "MARK_DOCUMENT_READ_GROW_UP_FARMS";
export const SET_GROW_UP_FARMS_READING_LOADING =
  "SET_GROW_UP_FARMS_READING_LOADING";
export const SUBMIT_GROW_UP_FARMS_QUESTIONNAIRE =
  "SUBMIT_GROW_UP_FARMS_QUESTIONNAIRE";
export const SUBMIT_GROW_UP_FARMS_FOOD_QUESTIONNAIRE =
  "SUBMIT_GROW_UP_FARMS_FOOD_QUESTIONNAIRE";
export const SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_LOADING =
  "SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_LOADING";
export const SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_RESULTS =
  "SET_GROW_UP_FARMS_FOOD_QUESTIONNAIRE_RESULTS";
export const MARK_DOCUMENT_READ_DAVIN_FOODS = "MARK_DOCUMENT_READ_DAVIN_FOODS";
export const SET_DAVIN_FOODS_READING_LOADING =
  "SET_DAVIN_FOODS_READING_LOADING";
export const SUBMIT_DAVIN_FOODS_QUIZ = "SUBMIT_DAVIN_FOODS_QUIZ";
export const SET_DAVIN_FOODS_QUIZ_LOADING = "SET_DAVIN_FOODS_QUIZ_LOADING";
export const SET_DAVIN_FOODS_QUIZ_RESULTS = "SET_DAVIN_FOODS_QUIZ_RESULTS";
export const SUBMIT_DAVIN_FOODS_FORM = "SUBMIT_DAVIN_FOODS_FORM";
export const POST_DAVIN_FOODS_FORM = "POST_DAVIN_FOODS_FORM";
export const POST_IPN_FORM = "POST_IPN_FORM";
export const SET_DAVIN_FOODS_QUIZ_SHOW_RESULTS =
  "SET_DAVIN_FOODS_QUIZ_SHOW_RESULTS";
export const SUBMIT_CLIENT_FORM_SILENT = "SUBMIT_CLIENT_FORM_SILENT";
